<template>
  <div>
    <v-chart :options="option" :autoresize="true" :style="{ height: '300%' }" />
    <!-- <div v-if="cpuvalue < 5 " class="statusgauge"> LOW </div>
    <div v-else-if="cpuvalue < 8" class="statusgauge"> Medium </div>
    <div v-else class="statusgauge"> HIGH </div> -->
  </div>
</template>

<script>
// import echarts from 'echarts'

export default {
  name: 'cpuChart',
  props: {
    data: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      cpuvalue: '',
      option: {
        title: {
          text: 'Resources',
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          data: this.data.map(function(item) {
            return item[0]
          }),
        },
        yAxis: {
          splitLine: {
            show: false,
          },
        },
        // dataZoom: [
        //   {
        //     startValue: '00:00:00',
        //   },
        //   {
        //     type: 'inside',
        //   },
        // ],
        visualMap: {
          top: 0,
          right: 0,
          pieces: [
            {
              gt: 0,
              lte: 65,
              color: '#096',
            },
            {
              gt: 65,
              lte: 80,
              color: '#ffde33',
            },
            {
              gt: 80,
              lte: 90,
              color: '#ff9933',
            },
            {
              gt: 90,
              color: '#cc0033',
            },
          ],
          outOfRange: {
            color: '#999',
          },
        },
        series: [
          {
            name: 'Disk Usage',
            type: 'bar',
            data: this.data.map(function(item) {
              return item[1]
            }),
          },
          {
            name: 'Memory Usage',
            type: 'bar',
            data: this.data.map(function(item) {
              return item[2]
            }),
          },
          {
            name: 'Swap Usage',
            type: 'bar',
            data: this.data.map(function(item) {
              return item[3]
            }),
          },
        ],
      },
    }
  },
}
</script>

<style>
.cpucharts {
  max-width: 100px;
  max-height: 100%;
}
.statusgauge {
  margin-top: -50px;
}
</style>
